/**
 * Configuración dinámica en runtime.
 * En Docker, Nginx sirve /config.json con las direcciones de los contratos.
 * En desarrollo, usa las variables de entorno de Vite (.env).
 */

let _config = null;

const DEFAULTS = {
  RPC_URL: import.meta.env.VITE_RPC_URL || 'https://bfpe-mainnet.blockchain.tkn.eus',
  WS_URL: import.meta.env.VITE_WS_URL || '',
  TOKEN_CONTRACT_ADDRESS: import.meta.env.VITE_TOKEN_CONTRACT_ADDRESS || '',
  NFT_CONTRACT_ADDRESS: import.meta.env.VITE_NFT_CONTRACT_ADDRESS || '',
  MARKETPLACE_CONTRACT_ADDRESS: import.meta.env.VITE_MARKETPLACE_CONTRACT_ADDRESS || '',
  CHAIN_ID: import.meta.env.VITE_CHAIN_ID || '1337',
  NETWORK_NAME: import.meta.env.VITE_NETWORK_NAME || 'BFPE Mainnet',
  EXPLORER_URL: import.meta.env.VITE_EXPLORER_URL || 'https://esploratzaile.blockchain.tkn.eus',
};

/**
 * Carga la configuración. Intenta /config.json (Docker) y si falla usa .env.
 */
export async function loadConfig() {
  if (_config) return _config;

  try {
    const res = await fetch('/config.json');
    if (res.ok) {
      const json = await res.json();
      _config = { ...DEFAULTS, ...json };
      console.log('✅ Config cargada desde /config.json');
      return _config;
    }
  } catch {
    // /config.json not available, use defaults
  }

  _config = { ...DEFAULTS };
  console.log('ℹ️ Config cargada desde variables de entorno');
  return _config;
}

/**
 * Obtiene la configuración ya cargada (síncrono).
 * Lanza error si no se ha llamado a loadConfig() antes.
 */
export function getConfig() {
  if (!_config) {
    // Fallback: devuelve defaults sin esperar fetch
    _config = { ...DEFAULTS };
  }
  return _config;
}
